export const getUserAvatarColor = (id: number) => {
  const palette = ['#6372A5', '#1D95F2', '#10D0AD', '#E13466', '#FFC422', '#FF9423', '#A233E1']

  return palette[id % palette.length]
}
